// extracted by mini-css-extract-plugin
export default {"page":"PaymentSuccess_page__EVbMH","content":"PaymentSuccess_content__gmW5N","receiptButton":"PaymentSuccess_receiptButton__6Ny3v","error":"PaymentSuccess_error__hpOpN"};